<app-page-meta pageTitle="finzy - Investment Application"></app-page-meta>
<app-header></app-header>
<div class="row mainrow">
  <div class="col-sm-4 leftdiv">
    <app-lenderleftdiv></app-lenderleftdiv>
  </div>
  <div class="col-sm-8 rightdiv">
    <div class="mobileleftdiv">
      <app-lender-registration-progress-bar></app-lender-registration-progress-bar>
    </div>
    <div class="rightinnerdiv">
      <p class="headtxt">Upload documents</p>

      <p class="txt1">Photograph</p>

      <div class="row form2">
        <div class="col-sm-8">
          <div class="file-placeholder">
            <input type="file" class="fileUpload" [disabled]="photoField" name="photo" [(ngModel)]="photo"
              (change)="fileChangePhoto($event)"
              (click)="analyticsTracker.trackButtonClick('Lender Upload Document','Photo Upload')"
              appAcceptFormats=".jpg,.jpeg,.png" toggleCamera="InSecureFile">
            <div class="file-browse">
              <span class="file-browse-txt">Upload your recent passport sized photograph</span>
              <span class="browse"><i class="material-icons">file_upload</i></span>
            </div>
          </div>
        </div>

        <div class="col-sm-2">
          <div *ngIf="loader1">
            <mat-spinner [diameter]="35" class="mat-spinner"></mat-spinner>
          </div>
        </div>

        <div class="col-sm-2">

        </div>


      </div>

      <span *ngIf="photoError" class="errormsg">Please upload photo to continue</span>
      <span *ngIf="photoErrorType"
            class="errormsg">File type not supported, please try uploading (.png/.jpeg/.jpg)</span>
      <span *ngIf="photoExistsError" class="errormsg">File already exists in the system, please try uploading a different file</span>
      <span *ngIf="photoSize" class="errormsg">Please upload file with filesize within 10MB</span>
      <div class="row" *ngIf="fileNamePhoto[0]">
        <div class="filetag col-sm-4" *ngFor="let item of fileNamePhoto; let i='index'">
          <app-download-file [receivedFile]=item></app-download-file>
          <i class="fa fa-times filetagclose" aria-hidden="true" id={{item._id}} (click)=removeFilePhoto($event)></i>
        </div>
      </div>

      <p class="txt1">PAN card</p>

      <div class="row form2">

        <div class="col-sm-8">
          <div class="file-placeholder">
            <input type="file" class="fileUpload" [disabled]="panField" [(ngModel)]="pan" name="pan"
              (change)="fileChangePan($event)"
              (click)="analyticsTracker.trackButtonClick('Lender Upload Document','PAN Upload')"
              appAcceptFormats=".pdf,.jpg,.jpeg,.png" toggleCamera="SecureFile">
            <div class="file-browse">
              <span class="file-browse-txt">Upload a copy of your PAN card </span>
              <span class="browse"><i class="material-icons">file_upload</i></span>
            </div>
          </div>
        </div>

        <div class="col-sm-2">
          <div *ngIf="loader">
            <mat-spinner [diameter]="35" class="mat-spinner"></mat-spinner>
          </div>
        </div>

        <div class="col-sm-2">

        </div>

      </div>

      <span *ngIf="panError" class="errormsg">Please upload PAN card to continue</span>
      <span *ngIf="panErrorType"
            class="errormsg">File type not supported, please try uploading (.png/.jpeg/.jpg/.pdf)</span>
      <span *ngIf="panExistsError" class="errormsg">File already exists in the system, please try uploading a different file</span>
      <span *ngIf="panSize" class="errormsg">Please upload file with filesize within 10MB</span>
      <div class="row" *ngIf="fileNameString[0]">
        <div class="filetag col-sm-4" *ngFor="let item of fileNameString; let i='index'">
          <app-download-file [receivedFile]=item></app-download-file>&nbsp;
          <i class="fa fa-times filetagclose" aria-hidden="true" id={{item._id}} (click)=removeFilePan($event)></i></div>
      </div>

      <div *ngIf="docType=='passport'">
        <p class="txt1">Passport</p>

        <div class="row form2">
          <div class="col-sm-8">
            <div class="file-placeholder">
              <input type="file" class="fileUpload" [disabled]="passportField" [(ngModel)]="passport" name="passport"
                (change)="fileChangePassport($event)"
                (click)="analyticsTracker.trackButtonClick('Lender Upload Document','Passport Upload')"
                appAcceptFormats=".pdf,.jpg,.jpeg,.png" toggleCamera="SecureFile">
              <div class="file-browse">
                <span class="file-browse-txt">Upload a copy of your Passport </span>
                <span class="browse"><i class="material-icons">file_upload</i></span>
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div *ngIf="loader2">
              <mat-spinner [diameter]="35" class="mat-spinner"></mat-spinner>
            </div>
          </div>

          <div class="col-sm-2">

          </div>


        </div>

        <span *ngIf="passportError" class="errormsg">Please upload Passport to continue</span>
        <span *ngIf="passportErrorType" class="errormsg">File type not supported, please try uploading (.png/.jpeg/.jpg/.pdf)</span>
        <span *ngIf="passportExistsError" class="errormsg">File already exists in the system, please try uploading a different file</span>
        <span *ngIf="passportSize" class="errormsg">Please upload file with filesize within 10MB</span>
        <div class="row" *ngIf="fileNamePassport[0]">
          <div class="filetag col-sm-4" *ngFor="let item of fileNamePassport; let i='index'">
            <app-download-file [receivedFile]=item></app-download-file>&nbsp;
            <i class="fa fa-times filetagclose" aria-hidden="true" id={{item._id}} (click)=removeFilePassport($event)></i></div>
        </div>
      </div>


      <div *ngIf="(docType=='aadhaar') || (extradocType =='aadhaar')">
        <p class="txt1">Masked e-Aadhaar</p>

        <div class="row form2">
          <div class="col-sm-8">
            <div class="file-placeholder">
              <input type="file" class="fileUpload" [disabled]="aadhaarField  || fileNameAadhaar.length > 0" [(ngModel)]="aadhaar" name="aadhaar"
                     [ngClass]="{ 'cursor-normal': fileNameAadhaar.length > 0 }"
                     (change)="fileChangeAadhaar($event)"
                     (click)="analyticsTracker.trackButtonClick('Lender Upload Document','Aadhaar Upload')"
                     appAcceptFormats=".pdf">
              <div class="file-browse">
                <span class="file-browse-txt">Upload your Masked e-Aadhaar</span>
                <span class="browse"><i class="material-icons">file_upload</i></span>
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div *ngIf="loader6">
              <mat-spinner [diameter]="35" class="mat-spinner"></mat-spinner>
            </div>
          </div>

          <div class="col-sm-2">

          </div>
        </div>

        <span *ngIf="aadhaarError" class="errormsg">Please upload Masked e-Aadhaar to continue</span>
        <span *ngIf="aadhaarErrorType" class="errormsg">Please try uploading (.pdf) file</span>
        <span *ngIf="aadhaarExistsError" class="errormsg">File already exists in the system, please try uploading a different file</span>
        <span *ngIf="aadhaarSize" class="errormsg">Please upload file with filesize within 10MB</span>
        <span *ngIf="aadhaarErrorDisplayText" class="errormsg">{{ aadhaarErrorDisplayText }}</span>
        <div class="row" *ngIf="fileNameAadhaar[0]">
          <div class="filetag col-sm-4" *ngFor="let item of fileNameAadhaar; let i='index'">
            <app-download-file [receivedFile]=item></app-download-file>&nbsp;
            <i class="fa fa-times filetagclose" aria-hidden="true" id={{item._id}} (click)=removeFileAadhaar($event)></i>
          </div>
        </div>

        <app-masked-aadhaar-info></app-masked-aadhaar-info>
      </div>


      <div *ngIf="docType=='drivinglicense'">
        <p class="txt1">Driving License</p>

        <div class="row form2">
          <div class="col-sm-8">
            <div class="file-placeholder">
              <input type="file" class="fileUpload" [disabled]="drivinglicenseField" [(ngModel)]="driving"
                     name="driving"
                     (change)="fileChangeDrivinglicense($event)"
                     (click)="analyticsTracker.trackButtonClick('Lender Upload Document','Driving License Upload')"
                	 appAcceptFormats=".pdf,.jpg,.jpeg,.png" toggleCamera="SecureFile">
              <div class="file-browse">
                <span class="file-browse-txt">Upload a copy of your Driving License </span>
                <span class="browse"><i class="material-icons">file_upload</i></span>
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div *ngIf="loader7">
              <mat-spinner [diameter]="35" class="mat-spinner"></mat-spinner>
            </div>
          </div>

          <div class="col-sm-2">

          </div>


        </div>

        <span *ngIf="drivingError" class="errormsg">Please upload Driving License to continue</span>
        <span *ngIf="drivingErrorType" class="errormsg">File type not supported, please try uploading (.png/.jpeg/.jpg/.pdf)</span>
        <span *ngIf="drivingExistsError" class="errormsg">File already exists in the system, please try uploading a different file</span>
        <span *ngIf="drivingSize" class="errormsg">Please upload file with filesize within 10MB</span>
        <div class="row" *ngIf="fileNameDrivinglicense[0]">
          <div class="filetag col-sm-4" *ngFor="let item of fileNameDrivinglicense; let i='index'">
            <app-download-file [receivedFile]=item></app-download-file>&nbsp;
            <i class="fa fa-times filetagclose" aria-hidden="true" id={{item._id}} (click)=removeFileDrivinglicense($event)></i></div>
        </div>
      </div>


      <div *ngIf="docType=='voterid'">
        <p class="txt1">Voter ID</p>
        <p class="txtbank2">Please upload both the front and back page of Voter ID so that the address section is
          visible</p>
        <div class="row form2">
          <div class="col-sm-8">
            <div class="file-placeholder">
              <input type="file" class="fileUpload" [disabled]="voteridField" [(ngModel)]="voter" name="voter"
                     (change)="fileChangeVoterid($event)"
                     (click)="analyticsTracker.trackButtonClick('Lender Upload Document','Voter Id Upload')"
                	 appAcceptFormats=".pdf,.jpg,.jpeg,.png" toggleCamera="SecureFile">
              <div class="file-browse">
                <span class="file-browse-txt">Upload a copy of your Voter ID </span>
                <span class="browse"><i class="material-icons">file_upload</i></span>
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div *ngIf="loader8">
              <mat-spinner [diameter]="35" class="mat-spinner"></mat-spinner>
            </div>
          </div>

          <div class="col-sm-2">

          </div>


        </div>

        <span *ngIf="voterError" class="errormsg">Please upload Voter ID to continue</span>
        <span *ngIf="voterErrorType" class="errormsg">File type not supported, please try uploading (.png/.jpeg/.jpg/.pdf)</span>
        <span *ngIf="voterExistsError" class="errormsg">File already exists in the system, please try uploading a different file</span>
        <span *ngIf="voterSize" class="errormsg">Please upload file with filesize within 10MB</span>
        <div class="row" *ngIf="fileNameVoterid[0]">
          <div class="filetag col-sm-4" *ngFor="let item of fileNameVoterid; let i='index'">
            <app-download-file [receivedFile]=item></app-download-file>&nbsp;
            <i class="fa fa-times filetagclose" aria-hidden="true" id={{item._id}} (click)=removeFileVoterid($event)></i>
          </div>
        </div>
      </div>


      <div *ngIf="docType=='lpg'">
        <p class="txt1">LPG Bill</p>

        <div class="row form2">
          <div class="col-sm-8">
            <div class="file-placeholder">
              <input type="file" class="fileUpload" [disabled]="lpgField" name="lpg" [(ngModel)]="lpg"
                     (change)="fileChangeLpg($event)"
                     (click)="analyticsTracker.trackButtonClick('Lender Upload Document','LPG Bill Upload')"
                	 appAcceptFormats=".pdf,.jpg,.jpeg,.png" toggleCamera="SecureFile">
              <div class="file-browse">
                <span class="file-browse-txt">Upload a copy of your most recent LPG Bill </span>
                <span class="browse"><i class="material-icons">file_upload</i></span>
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div *ngIf="loader10">
              <mat-spinner [diameter]="35" class="mat-spinner"></mat-spinner>
            </div>
          </div>

          <div class="col-sm-2">

          </div>


        </div>

        <span *ngIf="lpgError" class="errormsg">Please upload LPG Bill to continue</span>
        <span *ngIf="lpgErrorType"
              class="errormsg">File type not supported, please try uploading (.png/.jpg/.jpeg/.pdf)</span>
        <span *ngIf="lpgExistsError" class="errormsg">File already exists in the system, please try uploading a different file</span>
        <span *ngIf="lpgSize" class="errormsg">Please upload file with filesize within 10MB</span>
        <div class="row" *ngIf="fileNameLpg[0]">
          <div class="filetag col-sm-4" *ngFor="let item of fileNameLpg; let i='index'">
            <app-download-file [receivedFile]=item></app-download-file>&nbsp;
            <i class="fa fa-times filetagclose" aria-hidden="true" id={{item._id}} (click)=removeFileLpg($event)></i>
          </div>
        </div>
      </div>


      <div *ngIf="docType=='telephone'">
        <p class="txt1">Telephone Bill</p>

        <div class="row form2">
          <div class="col-sm-8">
            <div class="file-placeholder">
              <input type="file" class="fileUpload" [disabled]="telephoneField" name="telephone" [(ngModel)]="telephone"
                     (change)="fileChangeTelephone($event)"
                     (click)="analyticsTracker.trackButtonClick('Lender Upload Document','Telephone Bill Upload')"
                	 appAcceptFormats=".pdf,.jpg,.jpeg,.png" toggleCamera="SecureFile">
              <div class="file-browse">
                <span class="file-browse-txt">Upload a copy of your most recent BSNL/MTNL Telephone Bill </span>
                <span class="browse"><i class="material-icons">file_upload</i></span>
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div *ngIf="loader11">
              <mat-spinner [diameter]="35" class="mat-spinner"></mat-spinner>
            </div>
          </div>

          <div class="col-sm-2">

          </div>


        </div>

        <span *ngIf="telephoneError" class="errormsg">Please upload Telephone Bill to continue</span>
        <span *ngIf="telephoneErrorType" class="errormsg">File type not supported, please try uploading (.png/.jpg/.jpeg/.pdf)</span>
        <span *ngIf="telephoneExistsError" class="errormsg">File already exists in the system, please try uploading a different file</span>
        <span *ngIf="telephoneSize" class="errormsg">Please upload file with filesize within 10MB</span>
        <div class="row" *ngIf="fileNameTelephone[0]">
          <div class="filetag col-sm-4"
               *ngFor="let item of fileNameTelephone; let i='index'">
            <app-download-file [receivedFile]=item></app-download-file>
            <i class="fa fa-times filetagclose" aria-hidden="true" id={{item._id}} (click)=removeFileTelephone($event)></i></div>
        </div>
      </div>


      <div *ngIf="docType=='electricity'">
        <p class="txt1">Electricity Bill</p>

        <div class="row form2">
          <div class="col-sm-8">
            <div class="file-placeholder">
              <input type="file" class="fileUpload" [disabled]="electricityField" name="electricity"
                     [(ngModel)]="electricity"
                     (change)="fileChangeElectricity($event)"
                     (click)="analyticsTracker.trackButtonClick('Lender Upload Document','Electricity Bill Upload')"
                	 appAcceptFormats=".pdf,.jpg,.jpeg,.png" toggleCamera="SecureFile">
              <div class="file-browse">
                <span class="file-browse-txt">Upload a copy of your most recent Electricity Bill </span>
                <span class="browse"><i class="material-icons">file_upload</i></span>
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div *ngIf="loader12">
              <mat-spinner [diameter]="35" class="mat-spinner"></mat-spinner>
            </div>
          </div>

          <div class="col-sm-2">

          </div>


        </div>

        <span *ngIf="electricityError" class="errormsg">Please upload Electricity Bill to continue</span>
        <span *ngIf="electricityErrorType" class="errormsg">File type not supported, please try uploading (.png/.jpg/.jpeg/.pdf)</span>
        <span *ngIf="electricityExistsError" class="errormsg">File already exists in the system, please try uploading a different file</span>
        <span *ngIf="electricitySize" class="errormsg">Please upload file with filesize within 10MB</span>
        <div class="row" *ngIf="fileNameElectricity[0]">
          <div class="filetag col-sm-4" *ngFor="let item of fileNameElectricity; let i='index'">
            <app-download-file [receivedFile]=item></app-download-file>
            <i class="fa fa-times filetagclose" aria-hidden="true" id={{item._id}} (click)=removeFileElectricity($event)></i></div>
        </div>
      </div>

      <div class="row buttondiv">
        <div class="col-sm-6 backbtn">
          <button mat-stroked-button class="button-back primary" [routerLink]="['../invest/investment-preferences']"><i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;
            BACK
          </button>
        </div>
        <div class="col-sm-6 moveright">
          <app-forward-button class="button-forward" (click)="goToSummary(); analyticsTracker.trackButtonClick('Lender upload documents', 'NEXT')">
            NEXT
          </app-forward-button>
        </div>
      </div>
    </div>
  </div>
</div>


<app-footer></app-footer>


